<template>
  <div>
    <el-table
      :data="channellist"
      style="width: 100%"
      height="calc(100vh - 280px)"
    >
      <el-table-column label="id">
        <template slot-scope="scope">
          <!-- <i class="el-icon-time"></i> -->
          <span style="margin-left: 10px">{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column label="渠道邀请码">
        <template slot-scope="scope">
          <div slot="reference" class="name-wrapper">
            <el-tooltip
              class="item"
              effect="dark"
              content="点击进入详情"
              placement="top"
            >
              <a @click="handleCheckOrder(scope.row.id)">{{
                scope.row.channelCode
              }}</a>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="邀请人用户Id">
        <template slot-scope="scope">
          <div slot="reference" class="name-wrapper">
            <span>{{ scope.row.channelUserId }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="邀请人链接" width="320">
        <template slot-scope="scope">
          <div slot="reference" class="name-wrapper">
            <el-tooltip
              class="item"
              effect="dark"
              content="点击复制"
              placement="top"
            >
              <a @click="handleCopy(scope.$index, scope.row)"
                >{{ scope.row.channelUrl }}
                <i class="el-icon-document-copy"></i>
              </a>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="创建时间">
        <template slot-scope="scope">
          <div slot="reference" class="name-wrapper">
            <span>{{ scope.row.createTime | moment }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="更新时间">
        <template slot-scope="scope">
          <div slot="reference" class="name-wrapper">
            <span>{{ scope.row.updateTime | moment }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="渠道来源">
        <template slot-scope="scope">
          <!-- <el-popover trigger="hover" placement="top"> -->
          <!-- <p>姓名: {{ scope.row.name }}</p>
          <p>住址: {{ scope.row.address }}</p> -->
          <div slot="reference" class="name-wrapper">
            <span>{{ scope.row.note }}</span>
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column label="状态">
        <template slot-scope="scope">

          <div slot="reference" class="name-wrapper">
            <el-switch
              active-color="#13ce66"
            disabled
              @change="handleCodeStatusChange(scope.row, $event)"
              :value="scope.row.channelStatus==1 ? true : false"
            ></el-switch>
          </div>

        </template>
      </el-table-column> -->

      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            size="small"
            type="primary"
            circle
            icon="el-icon-edit"
            @click="handleEdit(scope.$index, scope.row)"
          ></el-button>
          <el-button
            size="small"
            type="danger"
            circle
            icon="el-icon-delete"
            @click="handleDelete(scope.$index, scope.row)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="修改渠道信息"
      width="600px"
      :visible.sync="dialogVisibleChange"
      @close="closeDialog"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <!-- <el-form-item label="链接zh" prop="zh">
          <el-input
            v-model="ruleForm.zh"
            placeholder="请输入链接名称(中文)"
          ></el-input>
        </el-form-item>
        <el-form-item label="链接en" prop="en">
          <el-input
            v-model="ruleForm.en"
            placeholder="请输入链接名称(英文)"
          ></el-input>
        </el-form-item>
        <el-form-item label="链接地址" prop="lineUrl">
          <el-input
            v-model="ruleForm.lineUrl"
            placeholder="请输入链接地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="理财链接地址" prop="financialUrl">
          <el-input
            v-model="ruleForm.financialUrl"
            placeholder="请输入链接地址"
          ></el-input>
        </el-form-item> -->

        <el-form-item label="用户Id" prop="channelUserId">
          <el-input
            v-model.trim="ruleForm.channelUserId"
            placeholder="请输入用户Id"
          ></el-input>
        </el-form-item>
        <el-form-item label="渠道来源" prop="note">
          <el-input
            v-model.trim="ruleForm.note"
            placeholder="请输入渠道信息"
          ></el-input>
        </el-form-item>
        <el-form-item label="渠道编码" prop="channelCode">
          <el-input
            v-model.trim="ruleForm.channelCode"
            placeholder="请输入渠道编码"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="状态" prop="status">
          <el-tooltip
            class="item"
            effect="dark"
            content="绿色为启用，红色则为未启用"
            placement="right"
          >
            <el-switch
              v-model="ruleForm.status"
              active-color="#13ce66"
              inactive-color="#ff4949"
            ></el-switch>
          </el-tooltip>
        </el-form-item> -->

        <el-form-item label-width="300px">
          <el-button type="primary" @click="updateUrL('ruleForm')"
            >确定修改</el-button
          >
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave('currencyForm')"
          >保存</el-button
        > -->
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex'
// import moment from 'moment'
import { ValidateLineUrl } from '../../validate'
export default {
  data() {
    return {
      dialogVisibleChange: false,
      result: true,
      ruleForm: {
        channelCode: '',
        channelUserId: '',
        note: '',
        copyData: null,
      },
      upperList: [],
      rules: {
        channelUserId: [
          {
            required: true,
            message: '请输入用户Id',
            trigger: 'blur',
          },
          // { message: "请输入线路名称", trigger: "blur" },
        ],
        note: [{ required: true, message: '请输入渠道信息', trigger: 'blur' }],
        channelCode: [
          { required: true, message: '请输入渠道编码', trigger: 'blur' },
        ],
      },
    }
  },
  mounted() {
    this.getDataList()
  },
  computed: {
    ...mapState('channel', ['codelist', 'channellist']),
    ...mapGetters('channel', ['filterList']),
    list() {
      return this.filterList.map((item) => item.locale.toUpperCase())
    },
  },
  methods: {
    ...mapActions('channel', ['getlist', 'delOne', 'updateOne', 'getUrlList']),
    getDataList() {
      this.getUrlList({ page: 1, size: 10, channelCode: '' })
      // this.codelist=res.data.list
    },
    handleCopy(index, row) {
      this.copyData = row.channelUrl
      this.copy(this.copyData)
    },
    handleCheckOrder(id) {
      this.$router.push(`/home/setting/channel/channelCodeInfo/${id}`)
      // this.$router.push(`/c2c/order/${order.id}`);
    },
    // copy(){
    //     document.execCommand("Copy"); // 执行浏览器复制命令
    //     this.$message({
    //       message: '复制成功',
    //       type: 'success'
    //     });
    //   },
    copy(data) {
      let url = data
      let oInput = document.createElement('input')
      oInput.value = url
      document.body.appendChild(oInput)
      oInput.select() // 选择对象;
      console.log(oInput.value)
      document.execCommand('Copy') // 执行浏览器复制命令
      this.$message({
        message: '复制成功',
        type: 'success',
        center: true,
      })
      oInput.remove()
    },

    handleClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          done()
        })
        .catch((_) => {})
    },
    handleEdit(index, row) {
      this.dialogVisibleChange = true
      this.ruleForm = Object.assign(this.ruleForm, { ...row })
    },
    handleDelete(index, row) {
      const id = row
      this.$confirm('确定要删除该渠道信息吗？', '提示', {
        type: 'warning',
      }).then(async () => {
        const res = await this.delOne({ ...row, isDel: !row.ieDel })
        if (res.code == 0) {
          this.$message.success('操作成功')
          this.getDataList()
        } else {
          this.$message.error('操作失败！请重试')
        }
      })
    },

    handleCodeStatusChange(row, status) {
      const message = status
        ? '确认要开启当前Url状态吗？'
        : '确认要关当前Url？关闭该Url，相应的选项也将关闭。'

      this.$confirm(message, '提示', { type: 'warning' }).then(async () => {
        if (row.status === 0) {
          row.status = 1

          const res = await this.updateOne(row)

          if (res.data == 1) {
            this.$message.success('操作成功')
          }
        } else if (row.status === 1) {
          row.status = 0

          const res = await this.updateOne(row)
          if (res.data == 1) {
            this.$message.success('操作成功')
          }
        }
      })
    },
    updateUrL(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          // this.ruleForm.status = Number(this.ruleForm.status);

          const res = await this.updateOne(this.ruleForm)
          if (res.code == 0) {
            this.$message.success('操作成功')
            this.dialogVisibleChange = false
            this.getDataList()
            this.result = true
          }
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    closeDialog() {},
  },
}
</script>

<style lang="less" scoped></style>
